export default {
  // 搜索框
  searchPlaceholder: "搜索幣種簡稱或代幣合約地址",

  // 合約信息提示
  notFoundData: "未找到符合搜索內容的數據 請修正後重試",

  // 幣種選項
  all: "全部",
  commonCurrencies: "常用幣種",
  contractTokens: "合約代幣",

  // 成功消息
  currencyModifiedSuccess: "幣種修改成功",
};
